export enum StatisticType {
	TOTAL = "TOTAL",
	REMAINING = "REMAINING",
	COMPLETED = "COMPLETED",
}
